var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSpeakerdeck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.11 13.8H4.99C2.51 13.8.5 11.79.5 9.31s2.01-4.5 4.49-4.5h5.97c.99 0 1.8.8 1.8 1.8s-.8 1.8-1.8 1.8H4.9c-.5 0-.9.4-.9.9s.4.9.9.9h5.12a4.49 4.49 0 110 8.98H2.3c-.99 0-1.8-.8-1.8-1.8s.8-1.8 1.8-1.8h7.81c.5 0 .9-.4.9-.9s-.4-.9-.9-.9zm3.78 5.39c1.19-.81 2.05-2.1 2.3-3.59h2.9c.49 0 .88-.4.88-.9V9.31c0-.5-.4-.9-.88-.9h-5.27c.42-.48.67-1.11.67-1.8s-.26-1.32-.67-1.8h6.15c1.95 0 3.53 1.61 3.53 3.59v7.19c0 1.98-1.58 3.59-3.53 3.59h-6.08z",
    fillRule: "evenodd"
  })));
}

export default SvgSpeakerdeck;